import React from 'react';

import { withStyles } from '@mui/styles';
import { TableCell, TableRow } from '@mui/material';

const styles = {
  row: {
    borderTop: '1px solid #FAFAFA',
    height: '51px',
  },
  cellTitle: {
    borderBottom: 'none',
    padding: '5px 5px 5px 10px',
  },
  cellContent: {
    borderBottom: 'none',
    padding: '5px',
  },
};

export default withStyles(styles)(({ classes, form_funcs, groupArrIndex, rstIndex, groupIndex, rst }) => (
  <TableRow className={classes.row}>
    <TableCell className={classes.cellTitle}>{rst.title}</TableCell>

    <TableCell className={classes.cellContent}>{form_funcs[`${groupArrIndex}_${groupIndex}_${rstIndex}`]}</TableCell>
  </TableRow>
));
